export const TRADES = [
  { name: "VRD", lower: "VRD", slug: "vrd", desc: "Voirie et réseaux divers : terrassement de réseaux, chaussées, assainissement." },
  { name: "Maçon", slug: "macon", desc: "Gros œuvre, fondations, élévation, dalles béton et ouvrages maçonnés." },
  { name: "Charpentier bois", slug: "charpentier-bois", desc: "Charpentes traditionnelles, ossatures bois, fermettes et lamellé-collé." },
  { name: "Charpentier métallique", slug: "charpentier-metallique", desc: "Structures métalliques, ossatures acier, passerelles et bâtiments industriels." },
  { name: "Terrassier", slug: "terrassier", desc: "Terrassement, décaissement, préparation de terrain et nivellement." },
  { name: "Couvreur", slug: "couvreur", desc: "Couverture tuiles, ardoise, zinc, étanchéité de toiture et zinguerie." },
  { name: "Façadier", slug: "facadier", desc: "Ravalement, enduits, bardage et traitement des façades." },
  { name: "Menuisier intérieur", slug: "menuisier-interieur", desc: "Agencement, escaliers, parquets, portes intérieures et placards." },
  { name: "Menuisier extérieur", slug: "menuisier-exterieur", desc: "Fenêtres, baies, volets, portes d'entrée et menuiseries PVC/alu/bois." },
  { name: "Chauffagiste climaticien", slug: "chauffagiste-climaticien", desc: "Chauffage, pompes à chaleur, climatisation et ventilation." },
  { name: "Plombier", slug: "plombier", desc: "Plomberie sanitaire, réseaux d'eau, salles de bains et dépannage." },
  { name: "Fumiste", slug: "fumiste", desc: "Conduits de fumée, ramonage, poêles et inserts." },
  { name: "Électricien", slug: "electricien", desc: "Installations électriques, mise aux normes, courants forts et faibles." },
  { name: "Carreleur", slug: "carreleur", desc: "Carrelage, faïence, mosaïque et dallage intérieur/extérieur." },
  { name: "Serrurier", slug: "serrurier", desc: "Serrurerie, métallerie, fermetures et blindage." },
  { name: "Peintre", slug: "peintre", desc: "Peinture intérieure/extérieure, revêtements muraux et finitions." },
  { name: "Vitrier", slug: "vitrier", desc: "Vitrage, miroiterie, double vitrage et verres de sécurité." },
  { name: "Poseur de revêtements souples", short: "revêtements souples", slug: "revetements-souples", desc: "Sol PVC, linoléum, moquette et revêtements souples." },
  { name: "Plâtrier plaquiste", slug: "platrier-plaquiste", desc: "Cloisons, plafonds suspendus, plâtrerie et finitions." },
  { name: "Spécialiste de l'isolation", short: "isolation", slug: "isolation", desc: "Isolation thermique et phonique, combles, murs et planchers." },
  { name: "Isolation par l'extérieur", short: "isolation extérieure", slug: "isolation-exterieure", desc: "ITE : bardage isolant, enduits isolants et traitement des ponts thermiques." },
  { name: "Agenceur", slug: "agenceur", desc: "Agencement de commerces, bureaux, mobilier sur mesure et aménagement." },
];

export const TRADE_NAMES = TRADES.map((t) => t.name);

// Nom du métier en minuscules dans une phrase (les sigles restent en capitales).
export const tradeLabel = (trade) => trade.lower || trade.name.toLowerCase();


export const CA_OPTIONS = [
  "Moins de 50 000 €",
  "50 000 € à 100 000 €",
  "100 000 € à 250 000 €",
  "250 000 € à 500 000 €",
  "500 000 € à 1 M€",
  "Plus de 1 M€",
];

export const SALARIES_OPTIONS = [
  "0 — aucun salarié",
  "1 à 2 salariés",
  "3 à 5 salariés",
  "6 à 9 salariés",
  "10 salariés et plus",
];

export const NAV_LINKS = [
  { to: "/", label: "Accueil" },
  { to: "/metiers", label: "Métiers" },
  { to: "/prix", label: "Prix" },
  { to: "/attestation", label: "Attestation" },
  { to: "/guide", label: "Guides" },
  { to: "/blog", label: "Blog" },
  { to: "/sante", label: "Santé" },
  { to: "/prevoyance", label: "Prévoyance" },
];
